import * as React from "react";

const SampleFilename = (props: { filename: string }) => (
  <span>{props.filename}</span>
);

export default SampleFilename;
